import React from "react";
import styles from "./styles.m.css";
import { get } from "lodash";
import { Link } from "@quintype/components";

const SpecificDateStories = data => {
  const year = Number(data.data.year);
  const month = Number(data.data.month);
  const date = Number(data.data.date);
  const collections = get(data, ["data", "stories"], []);
  const monthsStatic = [
    "",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  return (
    <div className="container">
      <div className={styles["sitemap-wrapper"]}>
        <h1 className={styles["header"]}>
          <Link href={`/site-map`}>Site Map</Link>
        </h1>
        <h3 className={styles["breadcrumb"]}>
          <Link href={`/site-map/${year}`}>{year}</Link> /
          <Link href={`/site-map/${year}/${month}`}>{monthsStatic[month]}</Link> / <Link>{date}</Link>
        </h3>
        {collections.length > 0 ? (
          <ol className={styles["story-head-col"]}>
            {collections.map((collection, index) => (
              <li key={index} className={styles["story-head-list"]}>
                <Link href={collection.url}>{collection.headline}</Link>
              </li>
            ))}
          </ol>
        ) : (
          <h2 className={styles["error-message"]}>
            Sorry! Articles of this date is not available,
            <br /> browse for some other date
          </h2>
        )}
      </div>
    </div>
  );
};

export { SpecificDateStories };
